import { render, staticRenderFns } from "./TableWlVisits.vue?vue&type=template&id=c14bf1b2&scoped=true"
import script from "./TableWlVisits.vue?vue&type=script&lang=js"
export * from "./TableWlVisits.vue?vue&type=script&lang=js"
import style0 from "./TableWlVisits.vue?vue&type=style&index=0&id=c14bf1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14bf1b2",
  null
  
)

export default component.exports